/**
 * Shipment API Service
 * 
 * Handles all API calls related to shipments
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  SHIPMENTS: '/shipment-tracking/shipments',
  SHIPMENT_BY_ID: (id) => `/shipment-tracking/shipments/${id}`,

  TRACKING: (carrierId, trackingNumber) => 
    `/external-carrier/status/${carrierId}/${trackingNumber}`,
  TRACKING_URL: (carrierId, trackingNumber) => 
    `/external-carrier/url/${carrierId}/${trackingNumber}`,
  SHIPMENT_ROUTE: (id) => `/shipment-tracking/shipments/${id}/route`,
  SHIPMENT_TELEMETRY: (id) => `/shipment-tracking/shipments/${id}/telemetry`,
};

// Create a function to get the current tenant ID


/**
 * Shipment API functions
 */
export const shipmentService = {
  // Get all shipments
  getShipments: async () => api.get('/shipment-tracking/shipments') ,
  // Get shipment by ID
  getShipmentById: (id) => api.get(ENDPOINTS.SHIPMENT_BY_ID(id)),
  
  // Tracking
  getTrackingInfo: async (carrierId, trackingNumber) => api.get(`/shipment-tracking/carriers/${carrierId}/tracking/${trackingNumber}`),
  
  // Get tracking URL from external carrier
  getTrackingUrl: (carrierId, trackingNumber) => api.get(ENDPOINTS.TRACKING_URL(carrierId, trackingNumber)),
    
  // Get shipment route
  getShipmentRoute: async (shipmentId) => api.get(`/shipment-tracking/shipments/${shipmentId}/route`),
  
  // Get shipment telemetry
  getShipmentTelemetry: async (shipmentId) => api.get(`/shipment-tracking/shipments/${shipmentId}/telemetry`),
  
}; 